<script lang="ts" generics="ITEM">
    import type {SearchParams, ViewableSearch} from 'typings/portaro.be.types';
    import type {Conjunction} from '../search-criteria/criteria.types';
    import type {SearchManager, SearchManagerState} from '../search-manager/search-manager';
    import type {Observable} from 'rxjs';
    import {exists} from 'shared/utils/custom-utils';
    import {getLocalization} from 'core/svelte-context/context';
    import KpSearchFacets from './KpSearchFacets.svelte';

    export let searchManager: SearchManager<ITEM>;

    const localize = getLocalization();

    let lastSearch: Observable<ViewableSearch<SearchParams, ITEM>>;
    $: lastSearch = searchManager.getLastSearch$();

    let searchManagerState: Observable<SearchManagerState>;
    $: searchManagerState = searchManager.getState$();

    function facetRestrictionChanged(facetRestriction: Conjunction) {
        searchManager.newSearchWithPartialParams({facetRestriction});
    }
</script>

{#if exists($lastSearch) && $lastSearch.features && $lastSearch.features.includes('faceting') && exists($lastSearch.result.availableFacets)}
    <section class="panel panel-default search-facet-panel" aria-label="{localize(/* @kp-localization hledani.vybratZVyhledanych */ 'hledani.vybratZVyhledanych')}">
        <KpSearchFacets availableFacets="{$lastSearch.result.availableFacets}"
                        selectedFacetConjunction="{$searchManagerState.frontendParams.facetRestriction}"
                        defaultExpandedFacets="{$lastSearch.defaultExpandedFacets}"
                        on:restrictions-change={(event) => facetRestrictionChanged(event.detail)}/>
    </section>
{/if}

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    :global {
        .search-facet-panel .facets-panel-body .facet {
            &:first-child .facet-name {
                border-top: none;
            }

            &:not(:first-child) {
                margin-top: @spacing-s;
            }

            .facet-name {
                padding-top: @spacing-s;
            }
        }
    }
</style>